import React from 'react';
import { SalesLetter } from './pages/SalesLetter';
export function App() {
  return <SalesLetter data-id="element-0" />;
}